import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.treatment-planner-marquee__splide' ).length ) {
        $( '.treatment-planner-marquee__splide' ).each( function( index, element ) {
          const slider = new Splide( $( element )[0], {
            type: 'loop',
            drag: 'free',
            gap: '2rem',
            arrows: false,
            autoWidth: true,
            pagination: false,
            autoScroll: {
              speed: .75,
              pauseOnFocus: false,
              pauseOnHover: false,
            },
          } );
          slider.mount( {AutoScroll} );

          const section = $( element );
          const sectionWidth = section.width();
          const doubleSectionWidth = sectionWidth * 2;
          let iterations = 0;
          const maxIterations = 10;
          let totalWidth = 0;
          const slides = section.find( `.splide__slide` );
          slides.each( function() {
            totalWidth += $( this ).width();
          } );

          while ( totalWidth < doubleSectionWidth && iterations < maxIterations ) {
            if ( totalWidth < doubleSectionWidth ) {
              slides.each( function() {
                // Clone each slide and append it to the marquee-track
                const clonedSlide = $( this ).clone();
                section.find( '.splide__list' ).append( clonedSlide );
                // Update the total width with the width of the cloned slide
                totalWidth += clonedSlide.width();
              } );
            }
            iterations++;
          }
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'treatment-planner-marquee', COMPONENT );
} )( app );
